<script lang="ts">
  /**
   * GridLines - Vertical grid lines for a section.
   *
   * Place at the top of each section. Lines are positioned at 9.03%
   * from viewport edges. Use `dark` for dark backgrounds (#333335)
   * or `light` for light backgrounds (#D3D3D3).
   *
   * Usage:
   *   <section class="relative">
   *     <GridLines variant="dark" />
   *     ...content...
   *   </section>
   */

  type Variant = 'dark' | 'light' | 'white';

  interface Props {
    /** "dark" for dark backgrounds, "light" for light backgrounds, "white" for white lines */
    variant?: Variant;
    /** Custom top offset (e.g., "350px" to start lines partway down) */
    top?: string;
  }

  let { variant = 'dark', top = '0' }: Props = $props();

  const color = $derived(variant === 'white' ? 'white' : variant === 'dark' ? '#333335' : '#D3D3D3');
</script>

<div
  class="hidden lg:block absolute left-[9.03%] bottom-0 w-px"
  style="top: {top}; background-color: {color};"
  aria-hidden="true"
></div>
<div
  class="hidden lg:block absolute right-[9.03%] bottom-0 w-px"
  style="top: {top}; background-color: {color};"
  aria-hidden="true"
></div>
